/* eslint-disable no-template-curly-in-string */
import { gql } from '@apollo/client';
import config from 'config';
import { Base64 } from 'utils/encoding';

const styleIndex = config.algolia.algolia_prefix + 'styles';
const itemIndex = config.algolia.algolia_prefix + 'items';
const reactionIndex = config.algolia.algolia_prefix + 'reactions';

const DATA_MAPPING = [
    {
        name: 'styleData',
        indexes: styleIndex,
        getIds: '(r) => [r?.doc?.style?.id]',
        skip: '(r) => !r?.doc?.style?.id',
    },
    {
        name: 'itemData',
        indexes: itemIndex,
        getIds: '(r) => [r?.doc?.item?.id]',
        skip: '(r) => !r?.doc?.item?.id',
    },
    {
        name: 'styleContext',
        indexes: styleIndex,
        getIds: '(r) => [r?.context?.style?.id]',
        skip: '(r) => !r?.context?.style?.id',
    },
];
export const USER_REACTIONS = gql`
query UserReactionsQuery ($query : String!, $filters: String!, $hit: Number, $page: Number) {
  reactions @algolia(__typename: "reactions", index: ${reactionIndex}, filters: $filters, hitsPerPage: $hit, page: $page, query: $query, populate: "${Base64.encode(
    JSON.stringify(DATA_MAPPING),
)}") {
      hitsPerPage
      page
      nbPages
      hits
      nbHits
  }
}
`;
